export function findValueInObject(keys: string[], source: any): any | boolean {
  for (const key of keys) {
    const keySplitted = key.split(key.indexOf('.') > -1 ? '.' : ' ');
    const value = keySplitted.reduce((p, c) => p && p[c] || undefined, source);
    if (value) {
      return value;
    }
  }

  return null;
}
